module.exports = __webpack_public_path__ + "assets/img/13.b0e758c2.png";